var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFileGif(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_file_GIF",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_57",
    "data-name": "\\uC0AC\\uAC01\\uD615 57",
    width: 40,
    height: 40,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_111",
    "data-name": "\\uADF8\\uB8F9 111",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_146",
    "data-name": "\\uD328\\uC2A4 146",
    d: "M7.942,27.149a2.229,2.229,0,1,0,0,4.457",
    fill: "#22ccb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_147",
    "data-name": "\\uD328\\uC2A4 147",
    d: "M6.139,29.378A1.782,1.782,0,0,1,7.67,27.63v-.879a2.64,2.64,0,0,0,0,5.254v-.879a1.782,1.782,0,0,1-1.531-1.748",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_148",
    "data-name": "\\uD328\\uC2A4 148",
    d: "M34.586,11.472,24.6,1.487a.423.423,0,0,0-.3-.125H13.455A5.791,5.791,0,0,0,7.671,7.146v19.6a2.665,2.665,0,0,1,.272-.027,2.636,2.636,0,0,1,.579.068V7.146a4.939,4.939,0,0,1,4.933-4.933H24.123l9.736,9.736v20.9a4.939,4.939,0,0,1-4.933,4.934H13.455a4.939,4.939,0,0,1-4.933-4.934v-.89a2.636,2.636,0,0,1-.579.068,2.665,2.665,0,0,1-.272-.027v.849a5.791,5.791,0,0,0,5.784,5.785H28.926a5.791,5.791,0,0,0,5.785-5.785V11.772a.423.423,0,0,0-.125-.3",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_149",
    "data-name": "\\uD328\\uC2A4 149",
    d: "M7.943,27.575a1.65,1.65,0,0,0-.273.055v3.5a1.65,1.65,0,0,0,.273.055,1.745,1.745,0,0,0,.578-.117V27.692a1.745,1.745,0,0,0-.578-.117",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_150",
    "data-name": "\\uD328\\uC2A4 150",
    d: "M8.522,31.964v-.9a1.777,1.777,0,0,1-.579.117,1.747,1.747,0,0,1-.272-.055V32a2.457,2.457,0,0,0,.272.028,2.7,2.7,0,0,0,.579-.068",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_151",
    "data-name": "\\uD328\\uC2A4 151",
    d: "M7.943,27.575a1.745,1.745,0,0,1,.578.117v-.9a2.634,2.634,0,0,0-.578-.068,2.714,2.714,0,0,0-.273.027v.879a1.65,1.65,0,0,1,.273-.055",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_152",
    "data-name": "\\uD328\\uC2A4 152",
    d: "M24.3,1.787l9.986,9.986H26.429a2.13,2.13,0,0,1-2.13-2.13Z",
    fill: "#e5e5e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_153",
    "data-name": "\\uD328\\uC2A4 153",
    d: "M34.286,12.2H26.429a2.558,2.558,0,0,1-2.555-2.555V1.787a.425.425,0,0,1,.726-.3l9.967,9.966a.426.426,0,0,1-.281.746M24.725,2.814V9.643a1.706,1.706,0,0,0,1.7,1.7h6.829Z",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_154",
    "data-name": "\\uD328\\uC2A4 154",
    d: "M8.145,16.526a2.4,2.4,0,0,0-2.4,2.4V28.96h.044a2.4,2.4,0,0,1,2.353-1.94H32.283V16.526Z",
    fill: "#22ccb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_155",
    "data-name": "\\uD328\\uC2A4 155",
    d: "M5.792,29.385H5.748a.424.424,0,0,1-.425-.425V18.923A2.825,2.825,0,0,1,8.145,16.1H32.283a.425.425,0,0,1,.426.425V27.019a.427.427,0,0,1-.426.427H8.145A1.971,1.971,0,0,0,6.21,29.04a.425.425,0,0,1-.418.345M8.145,16.951a1.974,1.974,0,0,0-1.971,1.972V27.4a2.823,2.823,0,0,1,1.971-.8H31.858V16.951Z",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_156",
    "data-name": "\\uD328\\uC2A4 156",
    d: "M13.577,22.134a2.628,2.628,0,0,1,2.637-2.875,2.312,2.312,0,0,1,1.7.706l-.58.7a1.473,1.473,0,0,0-1.084-.46c-.914,0-1.554.713-1.554,1.893,0,1.2.55,1.918,1.635,1.918a1.092,1.092,0,0,0,.683-.209V22.721h-.973v-.9H18V24.3a2.667,2.667,0,0,1-4.42-2.17",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_56",
    "data-name": "\\uC0AC\\uAC01\\uD615 56",
    width: 1.1,
    height: 5.506,
    transform: "translate(19.173 19.355)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_157",
    "data-name": "\\uD328\\uC2A4 157",
    d: "M21.623,19.355h3.388v.922H22.723v1.434h1.953v.922H22.723v2.228h-1.1Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileGif);
export default __webpack_public_path__ + "static/media/icon_file_GIF.cae066c015fa3c94f0a93e8b427ca256.svg";
export { ForwardRef as ReactComponent };